module.exports = __webpack_public_path__ + "static/img/anxun71.032a19b7.png";